// extracted by mini-css-extract-plugin
module.exports = {"categories":"Category_categories__29fU_"};